<template>
    <div class="w-full hidden md:block" v-if="!hidden">
        <PrimaryButton 
            @click="connectStripe"
            class="w-full stripe-connect-button group"
        >
            <div class="flex items-center justify-center space-x-3">
                <!-- Stripe Logo -->
                <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305h0z"/>
                </svg>
                
                <span class="font-semibold">Connect with Stripe</span>
                
                <!-- Arrow Icon -->
                <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
            </div>
        </PrimaryButton>
        
        <!-- Additional Info -->
        <div class="mt-3 text-center">
            <p class="text-xs text-gray-500 dark:text-gray-400">
                Fast and secure • 2-3 minutes
            </p>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import { useStorage } from '@/composables/use-storage.js';
import { useSystemSettings } from '@/composables/use-system-settings.js';
import { useLayoutComponents } from '@/composables/layout.js';

const { userInfo } = useStorage();
const { getSystemSetting } = useSystemSettings();
const { PrimaryButton } = useLayoutComponents();

const userInfos = ref(userInfo.value);
const clientId = getSystemSetting('STRIPE_CLIENT_ID');
const redirectUrl = window.location.origin + '/stripe/stripe-redirect'
const scope = 'read_write'
const emit = defineEmits(['update:hasStripeAccount']);
const props = defineProps({
    hidden: {
        type: Boolean,
        default: false
    }
})
const connectStripe = () => {
    if (props.hidden) {
        return;
    } else {
        const stripeUrlParams = new URLSearchParams({
            response_type: 'code',
            client_id: clientId,
            scope: scope,
            redirect_uri: redirectUrl,
            state: userInfos?.value?.id,
        });

        const url = `https://connect.stripe.com/oauth/authorize?${stripeUrlParams.toString()}`;
        window.open(url, '_blank');
        emit('update:hasStripeAccount', true);
    }
}
</script>

<style scoped lang="postcss">
.stripe-connect-button {
    @apply bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700;
    @apply shadow-lg hover:shadow-xl;
    @apply transform hover:-translate-y-0.5;
    @apply transition-all duration-200;
    @apply py-4;
}
</style>















